import styled, { keyframes } from 'styled-components';
export const SpinnerAnimation = keyframes`
 100% {
      transform: rotate(360deg);
    }
`;
export const Spinner = styled.svg`
  animation: ${SpinnerAnimation} 900ms linear infinite;
  display: inline-block;
  width: 50px;
  height: 50px;
`;